import { render, staticRenderFns } from "./HmFilterHot.vue?vue&type=template&id=b28f2132&scoped=true&"
import script from "./HmFilterHot.vue?vue&type=script&lang=js&"
export * from "./HmFilterHot.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b28f2132",
  null
  
)

component.options.__file = "HmFilterHot.vue"
export default component.exports